import React, { useState } from 'react';
import { CollectionItemTab } from './CollectionItemTab';
import { CollectionActivityDrop } from './CollectionActivityDrop';

const CollectionTabsForDrop = (props) => {
  const [activeTab, setActiveTab] = useState('Items');

  const contractAddress = props.contractAddress;
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <div className="main-container">
      <div className="tab-container">
        <div className="tabs">
          {['Items', 'Offers', 'Analytics', 'Activity'].map((tabName) => (
            <div
              key={tabName}
              className={`tab ${activeTab === tabName ? 'active' : ''}`}
              onClick={() => handleTabClick(tabName)}
            >
              {tabName}
            </div>
          ))}
        </div>
        <div className="tab-content">
          {activeTab === 'Items' && (
            <CollectionItemTab contractAddress={contractAddress} />
          )}
          {activeTab === 'Offers' && <div className="content">Offers Content</div>}
          {activeTab === 'Analytics' && <div className="content">Analytics Content</div>}
          {activeTab === 'Activity' && 
          <CollectionActivityDrop contractAddress={contractAddress} />}
        </div>
      </div>
    </div>
  );
};

export default CollectionTabsForDrop;
